import { useRef } from 'react';
import PropTypes from 'prop-types';
import useScrollDock from './useScrollDock';
import './BleedOnScroll.css';

/**
 * BleedOnScroll — блок разъезжается на всю ширину, когда до него домотали
 * (#1330).
 *
 * Подложка блока уходит полями за контейнер к самым кромкам окна ровно
 * настолько, насколько блок подтянули прокруткой: хук пишет долю пути в
 * `--bleed-dock`, а поля до кромок — в `--bleed-start` / `--bleed-end`.
 *
 * ## Почему обёртка, а не сам блок
 *
 * Раскрытие — это отрицательные поля, и мерить расстояние до кромок надо по
 * тому, кто стоит на месте. Сам блок к моменту замера уже уехал краями за
 * контейнер, и замер по нему гонялся бы за собственным хвостом. Обёртка
 * границ не меняет: её ширину задаёт контейнер, а поля висят на ней же и на
 * её собственную ширину не влияют.
 *
 * ## Скругление — дело блока внутри
 *
 * Компонент двигает только поля. Скругление у каждого блока своё (у карты оно
 * на самой карте, у карточки — на карточке), поэтому его гасят там же,
 * множителем `(1 - var(--bleed-dock))`.
 *
 * Лежит в `pages/shared/` — в бандл дилера не едет.
 */
export const BleedOnScroll = ({ children, className = '' }) => {
  const ref = useRef(null);
  useScrollDock(ref, { name: 'bleed', bleed: true });

  return (
    <div ref={ref} className={`bleed-on-scroll ${className}`.trim()}>
      {children}
    </div>
  );
};

BleedOnScroll.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default BleedOnScroll;
